/*
 * @Author: JamesWong
 * @Description:  i18n 主入口
 * @Date: 2018-11-28 13:56:49
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-12-04 14:48:30
 */
import zhCn from './zh-cn'
import zhHant from './zh-hant'
import en from './en'
// 随便吧 补补补
import zhCnPreview from './zh-cn/preview'
import zhHantPreview from './zh-hant/preview'
import enPreview from './en/preview'
// element语言包
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import twLocale from 'element-ui/lib/locale/lang/zh-TW'

export default {
  //  简体中文
  'zh-cn': {
    ...zhCn,
    ...zhLocale,
    ...zhCnPreview
  },
  // 繁体中文
  'zh-hant': {
    ...zhHant,
    ...twLocale,
    ...zhHantPreview
  },
  'en': {
    ...en,
    ...enLocale,
    ...enPreview
  }
}


// WEBPACK FOOTER //
// ./src/i18n/index.js